define.alias("ember-truth-helpers/helpers/is-equal", "settings/helpers/is-equal");